import {
  Media,
  MediaStatus,
  MediaType,
} from '@/model/media'

import { User } from './user'

export interface Post {
  comment: number
  created_at: string
  currency: number
  id: number
  is_liked: boolean
  like: number
  media: string

  price: number
  title: string
  type: MediaType
  uid: number
}
export interface PostResponse {
  post: Post
  user: User
}

export const convertPostResponseToMedias = ({
  post: { id, type, media },
}: { post: Post }): Media[] => {
  if (type === MediaType.Video) {
    return [{
      id,
      status: MediaStatus.Ready,
      type,
      src: media,
    }]
  }

  return media.split(',').map((url, index) => {
    return {
      // temp id, there's no unique media id in post response
      id: Number(`${id}0000${index}`),
      status: MediaStatus.Ready,
      type,
      src: url,
    }
  })
}